import React, { useState } from "react";
import {ProfileModel} from "../../features/profile/profileTypes";
import {useFormErrors} from "../../features/formErrors/formErrors";
import ImageCropper from "../ImageCropper/ImageCropper";
import {useUpdateUserBanner} from "../../features/profile/profileApi";
import toast from "react-hot-toast";
import {useLoading} from "../../context/LoadingContext";

type Props = {
    profile: ProfileModel;
}

const BannerElement = ({profile}: Props) => {
    const {mutate: updateBanner} = useUpdateUserBanner();
    const {handleError, clearErrors, renderError} = useFormErrors();
    const [bannerEdit, setBannerEdit] = useState<boolean>(false);
    const {setLoading} = useLoading();

    const onBannerCropApplied = (image: Blob, filename: string, type: string) => {
        setLoading(true);

        updateBanner({banner: new File([image], filename, {type: type})}, {
            onError: handleError,
            onSuccess: () => {
                setLoading(false);
                clearErrors();
                toast.success('Banner updated');
                setBannerEdit(false);
            },
        });


    };

    const handleCropCancel = () => {
        setBannerEdit(false);
    }

    return (
        <>
            {!bannerEdit &&
                <>
                    <label className="form-label">Banner</label>
                    <div>
                        <img className='img-fluid' src={profile.banner} alt='avatar'/>
                    </div>
                    <button className='btn btn-sm btn-primary mt-1 slide-top' type='button' onClick={() => {
                        setBannerEdit(true)
                    }}>EDIT BANNER
                    </button>
                    {renderError("banner")}
                </>
            }

            {bannerEdit &&
                <>
                    <label className="form-label">Banner</label>
                    <ImageCropper image={profile.banner} aspect={4} cropShape='rect' onCropApplied={onBannerCropApplied}
                                  onCancel={handleCropCancel}/>
                    {renderError("banner")}
                </>
            }
        </>
    );
};

export default BannerElement;
